import {
    COMPLAINT_DATA
  } from "../constant/user";
  
const initialState = {
  complaintDetails: []
};


const ComplaintDeatailReducer = (state=initialState,action)=>{
    const { type, payload } = action;
    switch(type){
        case COMPLAINT_DATA:
            return {...state, complaintDetails: payload }
        default:
            return state;
    }
}

export default ComplaintDeatailReducer;